import type { ColumnDef, SortingFn } from '@tanstack/vue-table'
import { Button } from '~/components/ui/button'
import BarsArrowUp from '~/components/BarsArrowUp.vue'

interface DataItem {
  id?: string
  name: string
  formatted_date?: string
}

const localeCompareSorting: SortingFn<DataItem> = (rowA, rowB) => {
  const valueA = rowA.original.formatted_date || rowA.original.name
  const valueB = rowB.original.formatted_date || rowB.original.name

  return valueA.localeCompare(valueB, undefined, {
    sensitivity: 'base',
    numeric: true,
  })
}

export const createColumns = (type: string): ColumnDef<DataItem, string>[] => {
  const headerTitle = type === 'assets' ? 'Asset' : 'Reporting Year'

  return [
    {
      accessorFn: row => row.formatted_date || row.name,
      id: 'displayName',
      enableSorting: true,
      sortingFn: localeCompareSorting,
      header: ({ column }) => {
        const isSorted = column.getIsSorted()
        const sortIconStyling = isSorted === 'asc' ? 'text-green-500' : isSorted === 'desc' ? 'text-red-500 !rotate-0' : ''

        return h('div', { class: 'flex justify-between items-center' }, [
          h('span', { class: 'text-sm text-slate-800 font-semibold capitalize' }, headerTitle),
          h(Button, {
            class: 'text-main-primary',
            variant: 'ghost',
            onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
          }, () => h(BarsArrowUp, { customStyle: `size-5 rotate-180 ${sortIconStyling}` })),
        ])
      },
      cell: ({ getValue }) => {
        return h('span', {
          class: 'text-md text-foreground',
          title: getValue(),
        }, getValue())
      },
      size: 200,
    },
  ]
}
